'use client';

import { c as _c } from "react/compiler-runtime";
import ListItemButton from '@mui/material/ListItemButton';
import { Modal } from '@/app/_shared/components/Modal';
import { type Changelog } from 'resonetics-webapps-modules';
import { useState } from 'react';
import packageJson from '@/package.json';
import Table from '@mui/material/Table';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import Box from '@mui/material/Box';
import React from 'react';
import HorizontalRule from '@mui/icons-material/HorizontalRule';
interface VersionChangelogButtonProps {
  changelog: Changelog;
}
export const VersionChangelogButton: React.FC<VersionChangelogButtonProps> = t0 => {
  const $ = _c(8);
  const {
    changelog
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ListItemButton onClick={() => setIsOpen(true)} sx={_temp}>v{packageJson.version}</ListItemButton>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setIsOpen(false);
    t3 = {
      sx: {
        display: "flex",
        flexDirection: "column",
        gap: 3
      }
    };
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== changelog) {
    t4 = changelog.map(_temp5);
    $[3] = changelog;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== isOpen || $[6] !== t4) {
    t5 = <>{t1}<Modal title="Changelog" isOpen={isOpen} onClose={t2} ContentProps={t3}>{t4}</Modal></>;
    $[5] = isOpen;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
function _temp(t0) {
  const {
    palette,
    typography
  } = t0;
  return {
    color: palette.grey[300],
    fontSize: typography.caption,
    p: 0,
    pl: 0.3
  };
}
function _temp2(t0) {
  const [, changes] = t0;
  return changes.length > 0;
}
function _temp3(t0) {
  const {
    palette: palette_0
  } = t0;
  return {
    borderBottom: `2px solid ${palette_0.grey[600]}`
  };
}
function _temp4(change, i) {
  return <ListItem key={i}><Typography fontSize={15}><HorizontalRule sx={{
        fontSize: 12,
        mr: 1
      }} />{change}</Typography></ListItem>;
}
function _temp5(release) {
  const filteredChanges = Object.entries(release.changes).filter(_temp2);
  return <Table key={release.version}><TableHead sx={_temp3}><TableRow><TableCell sx={{
          fontWeight: 600,
          fontSize: 20
        }}>{release.version}</TableCell><TableCell sx={{
          fontWeight: 400,
          fontSize: 16,
          textAlign: "right"
        }}>{release.date}</TableCell></TableRow></TableHead><TableBody>{filteredChanges.map((t0, rowI) => {
        const [changeType, changes_0] = t0;
        return <TableRow key={changes_0}><TableCell colSpan={2} sx={{
            fontWeight: 600,
            pt: 2,
            borderBottom: rowI === filteredChanges.length - 1 ? "none" : undefined
          }}><Box>{changeType}{(changes_0 as string[]).map(_temp4)}</Box></TableCell></TableRow>;
      })}</TableBody></Table>;
}